import { RecipientStatusList } from "./RecipientStatusList";
export default RecipientStatusList;
export * from "./RecipientStatusList";
